import { Head, Link } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import { formatDate } from "@/lib/date-utils"
import type { BreadcrumbItem } from "@/types"

interface PendingReport {
  id: number
  report_date: string | null
  case_id: number
  case_name: string | null
  case_number: string | null
  leader_name: string | null
  entries_prepared: number
}

interface Props {
  reports: PendingReport[]
}

export default function PendingPreparation({ reports }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Reports", href: "#" },
    { title: "Pending Preparation", href: "/reports/pending_preparation" },
  ]

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Reports to be Prepared" />

      <div className="p-6">
        <h1 className="mb-6 text-2xl font-semibold">Reports to be Prepared</h1>

        {reports.length > 0 ? (
          <div className="border-hpi-light-gray rounded border bg-white">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-hpi-light-gray border-b bg-gray-50">
                  <th className="px-4 py-3 text-left font-medium">Date</th>
                  <th className="px-4 py-3 text-left font-medium">Case</th>
                  <th className="px-4 py-3 text-left font-medium">Leader</th>
                  <th className="px-4 py-3 text-right font-medium">Status</th>
                </tr>
              </thead>
              <tbody>
                {reports.map((report) => (
                  <tr
                    key={report.id}
                    className="border-hpi-light-gray border-b last:border-0"
                  >
                    <td className="px-4 py-3">
                      <Link
                        href={`/cases/${report.case_id}/reports/${report.id}/prepare`}
                        className="text-hpi-active-blue"
                      >
                        {formatDate(report.report_date)}
                      </Link>
                    </td>
                    <td className="px-4 py-3">
                      <Link
                        href={`/cases/${report.case_id}`}
                        className="text-hpi-active-blue"
                      >
                        {report.case_name}
                      </Link>
                    </td>
                    <td className="px-4 py-3">
                      <Link
                        href={`/cases/${report.case_id}/reports/${report.id}/prepare`}
                        className="text-hpi-active-blue"
                      >
                        {report.leader_name}
                      </Link>
                    </td>
                    <td className="px-4 py-3 text-right">
                      <Link
                        href={`/cases/${report.case_id}/reports/${report.id}/prepare`}
                        className="text-hpi-active-blue"
                      >
                        {report.entries_prepared > 0 ? "In Progress" : "New"}
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="rounded border border-green-300 bg-green-50 p-4 text-center text-green-700">
            No Pending Reports found
          </div>
        )}
      </div>
    </AppLayout>
  )
}
